import { UserInfo } from "./business-base";

export interface QueryParams {
  sortExpression?: string;
  skip?: number;
  take?: number;
}

export interface QueryFilter {
  canClear(hint?);
  clear(hint?);
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  fileName?: string;
}

export interface UploadedFile {
  id: number;
  fileName: string;
  extension: string | null;
  sizeInBytes: number;
  storageFileId: string;
  uploadedOn: string;
  uploadedBy: UserInfo;
}
